export const navItems = [
  { label: 'Overview', path: 'overview' },
  { label: 'Invoices', path: 'invoices' },
  { label: 'Contracts', path: 'contracts' },
  { label: 'Credit notes', path: 'credit-notes' },
  { label: 'Settings', path: 'settings' },
];
